import { hasText } from 'shared/lib/common-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0250Validator = {
  validateNameAndAddressRequirement: (identificationNumber?: string): RuleResult => (hasText(identificationNumber) ? 'NOT_ALLOWED' : 'REQUIRED'),
}

export default C0250Validator
